import { render, staticRenderFns } from "./OrderCard.vue?vue&type=template&id=f30bbf5c&scoped=true"
import script from "./OrderCard.vue?vue&type=script&lang=js"
export * from "./OrderCard.vue?vue&type=script&lang=js"
import style0 from "./OrderCard.vue?vue&type=style&index=0&id=f30bbf5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30bbf5c",
  null
  
)

export default component.exports